import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTopicPage_Views_ActivityQuery, ItemType } from "sprout-graphql";
import update from "immutability-helper";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import { Glitch, NotFound } from "@sprout/views";
import Head from "@sprout/client-layout/dist/Head";
import TrackJumpHistory from "@sprout/client-components/dist/TrackJumpHistory";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import TopicPagePage from "../TopicPage_Page";
import TopicPageViewsActivityMain from "./TopicPage_Views_Activity_Main";
const TopicPageViewsActivity = ()=>{
    var ref2;
    const { topicId  } = useParams();
    const { loading , data , fetchMore , error  } = useTopicPage_Views_ActivityQuery({
        variables: {
            topicId: Number(topicId)
        },
        fetchPolicy: "cache-and-network"
    });
    const activities = data === null || data === void 0 ? void 0 : data.activities;
    const topic = data === null || data === void 0 ? void 0 : data.topic;
    const pageInfo = activities === null || activities === void 0 ? void 0 : activities.pageInfo;
    const { endCursor =null , hasNextPage =false  } = pageInfo || {};
    const isInitialLoad = loading && !activities;
    useLoadingProgress(isInitialLoad);
    const showSnackbar = useSnackbar();
    const loadMore = useCallback(()=>{
        fetchMore({
            variables: {
                topicId: Number(topicId),
                endCursor
            },
            updateQuery (prevResult, { fetchMoreResult  }) {
                var ref, ref1;
                const fetchMoreResultsNodes = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (ref = fetchMoreResult.activities) === null || ref === void 0 ? void 0 : ref.nodes;
                const fetchMoreResultsPageInfo = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (ref1 = fetchMoreResult.activities) === null || ref1 === void 0 ? void 0 : ref1.pageInfo;
                if (fetchMoreResultsNodes && fetchMoreResultsPageInfo) return update(prevResult, {
                    activities: {
                        nodes: {
                            $push: fetchMoreResultsNodes
                        },
                        pageInfo: {
                            $set: fetchMoreResultsPageInfo
                        }
                    }
                });
                return prevResult;
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        endCursor,
        fetchMore,
        showSnackbar,
        topicId
    ]);
    if (isInitialLoad) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!activities || !topic || topic.type !== ItemType.Topic || !topic.isRootTopic || ((ref2 = topic.rootTopicOrSelf) === null || ref2 === void 0 ? void 0 : ref2.special) === "PROFILE") return /*#__PURE__*/ _jsx(NotFound, {});
    const { title , linkImages , description , id  } = topic;
    const metaTagImage = linkImages && linkImages[0];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TrackJumpHistory, {
                type: ItemType.Topic,
                data: {
                    itemId: id,
                    view: "ACTIVITY"
                }
            }),
            /*#__PURE__*/ _jsx(Head, {
                title: title ? `${title} (Activity) | Sprout` : "Sprout",
                description: description,
                image: metaTagImage
            }),
            /*#__PURE__*/ _jsx(TopicPagePage, {
                topic: topic,
                main: /*#__PURE__*/ _jsx(TopicPageViewsActivityMain, {
                    topic: topic,
                    activities: activities.nodes,
                    loading: loading,
                    hasNextPage: hasNextPage,
                    loadMore: loadMore
                })
            })
        ]
    });
};
export default TopicPageViewsActivity;
